<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError) {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.mes-production-terminal.reorder-dialog.error.http' | translate }}
		</mat-error>
	}

	<h1 mat-dialog-title class="notification-title">
		{{ 'mes.mes-production-terminal.reorder-dialog.title' | translate: { alias: chosenItemOperation.alias } }}
	</h1>

	<mat-dialog-content>
		<div class="reorder-layout pad-top-20">
			<div class="reorder-left">
				<mat-form-field appearance="outline" class="dialog">
					@if (controls['sequenceNumber'].invalid && controls['sequenceNumber'].touched) {
						<mat-error>
							{{ 'mes.mes-production-terminal.reorder-dialog.error.sequence-number' | translate }}
						</mat-error>
					}
					<mat-label class="mat-body-1">
						{{ 'mes.mes-production-terminal.reorder-dialog.sequence-number' | translate }}
					</mat-label>
					<mat-select formControlName="sequenceNumber">
						@for (sequenceNumber of reordableSequenceNumbers; track sequenceNumber) {
							<mat-option [value]="sequenceNumber">
								{{ sequenceNumber }}
							</mat-option>
						}
					</mat-select>
				</mat-form-field>

				<mat-form-field appearance="outline" class="dialog">
					@if (controls['employee'].invalid && controls['employee'].touched) {
						<mat-error>
							{{ 'mes.mes-production-terminal.reorder-dialog.error.employee' | translate }}
						</mat-error>
					}
					<mat-label class="mat-body-1">
						{{ 'mes.mes-production-terminal.reorder-dialog.employee' | translate }}
					</mat-label>
					<input matInput formControlName="employee" cdkFocusInitial />
				</mat-form-field>

				<app-incident-code-select
					[incidentCodesByGroup]="incidentCodesByGroup"
					[labelKey]="'mes.mes-production-terminal.reorder-dialog.incident-code'"
					[errorKey]="'mes.mes-production-terminal.reorder-dialog.error.incident-code'"
					[control]="incidentCodeControl"
					(selectionChange)="onSelectionChange()"></app-incident-code-select>
			</div>

			<div class="reorder-right">
				<mat-form-field appearance="outline" class="dialog note-field">
					<mat-label class="mat-body-1">
						{{ 'mes.mes-production-terminal.reorder-dialog.note' | translate }}
					</mat-label>
					<textarea matInput formControlName="note" rows="10" maxlength="255"></textarea>
				</mat-form-field>
			</div>
		</div>
		@if (chosenItemOperation?.alias) {
			<app-reorder-production-note-list [alias]="$safeNavigationMigration(chosenItemOperation?.alias)" [employees]="employees" />
		}
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-flat-button color="primary" type="submit" [disabled]="form.invalid || loading">
			{{ 'general.ok' | translate }}
		</button>
		<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">
			{{ 'general.cancel' | translate }}
		</button>
	</mat-dialog-actions>
</form>
